/**
 * compiler for version 2_6_11
 * @param {string} editorScript
 */
const compiler2_6_11 = ({ editorScript, components, mixins }) => {
	if (!editorScript) return ""

	// Combine components and mixins to define imports statements
	const imports = [...components, ...mixins].map(item => `import ${item} from "./${item}"`).join("\n")

	// Inject `components` and `mixins` into editorScript string right after the first "{"
	const componentsStringFragment = components?.length ? `components:{${components.join(",")}},\n` : ""
	const mixinsStringFragment = mixins?.length ? `mixins:[${mixins.join(",")}],\n` : ""
	const editorScriptWithComponentsAndMixins = editorScript.replace(
		"{", // replace first "{"
		`{\n ${componentsStringFragment} ${mixinsStringFragment}`
	)

	// Compose final string
	let output = ``
	output += `${imports} \n\n`
	output += `export default ${editorScriptWithComponentsAndMixins}`

	return output
}

/**
 * Versioned compilers
 */
const compilersProvider = {
	"2.6.11": compiler2_6_11
}

/**
 * compileVueTemplateToEditorScript
 * @param {string} editorScript
 * @param {array} components - List of strings, names of components to import
 * @param {array} mixins - List of strings, names of mixins to import
 * @param {string} version
 */
export default ({ editorScript, components = [], mixins = [], version = "" }) => {
	const compiler = compilersProvider[version]
	if (!compiler) throw new Error(`There is no compiler for Vue of version ${version} available`)

	return compiler({ editorScript, components, mixins })
}
